import React from 'react';
import "../styles.scss";
import icon from '../assets/swiftIcon.png';
import { useLanguage } from '../context/LanguageContext';

const Navbar = () => {
    const { language, setLanguage, t } = useLanguage();

    return (
        <div className='navbar-position'>
            <div className='container'>
                <nav className="navbar navbar-expand-lg navbar-dark navbar-style">
                    <a className="navbar-brand" href="#home" aria-label={t.nav.goHome}>
                        <img src={icon} width="30" height="30" alt="Swift logo" />
                    </a>
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNavAltMarkup"
                        aria-controls="navbarNavAltMarkup"
                        aria-expanded="false"
                        aria-label={t.nav.toggleNavigation}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
                        <div className="navbar-nav ms-auto">
                            <a className="nav-link" href="#home">{t.nav.home}</a>
                            <a className="nav-link" href="#featured">{t.nav.featured}</a>
                            <a className="nav-link" href="#experience">{t.nav.experience}</a>
                            <a className="nav-link" href="#skills">{t.nav.skills}</a>
                            <a className="nav-link" href="#about">{t.nav.about}</a>
                        </div>
                        <div className="language-switcher" aria-label={t.nav.language}>
                            <button
                                type="button"
                                className={`language-switcher-button ${language === 'en' ? 'active' : ''}`}
                                onClick={() => setLanguage('en')}
                            >
                                EN
                            </button>
                            <button
                                type="button"
                                className={`language-switcher-button ${language === 'pt' ? 'active' : ''}`}
                                onClick={() => setLanguage('pt')}
                            >
                                PT
                            </button>
                        </div>
                    </div>
                </nav>
            </div>
        </div >
    );
};

export default Navbar;
